import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Checkbox,
  ListItemText,
  Chip,
  FormHelperText
} from '@material-ui/core';
import React, { lazy, Suspense } from 'react';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { arrToVarArr, stringToVar } from '../../lib/components/formatter';
import {
  BUTTON_TAGS_CARD, CAT_CHART, CAT_CONTROL, CAT_LIST, getControlReverse, INPUT_NUMBER_TAGS_CARD, INPUT_TOGGLE_TAGS_CARD,
  isCommand, TYPE_AMPERE, TYPE_CARD_VALUE, TYPE_CUSTOM, TYPE_GRAPH_AREA_MONITORING, TYPE_GRAPH_BAR_MONITORING, TYPE_GRAPH_LINE_MONITORING,
  TYPE_GRAPH_PIE, TYPE_HUMIDITY, TYPE_KW, TYPE_KWH, TYPE_LIST, TYPE_LIST_CUSTOM, TYPE_LIST_TRANSACTION, TYPE_MAP, TYPE_OHM, TYPE_PERCENT,
  TYPE_PRESSURE_AIR, TYPE_PRESSURE_WATER, TYPE_RUPIAH, TYPE_TEMPERATURE_CELCIUS, TYPE_TEMPERATURE_FAHRENHEIT, TYPE_TEMPERATURE_KELVIN,
  TYPE_THREE_PHASE, TYPE_TITLE, TYPE_VERSION, TYPE_VOLT, TYPE_WATT, isNormalCommand, isCommandCard, isTagsAvailable,
  TYPE_DROPDOWN_SELECTOR, INPUT_TEXT_TAGS_CARD
} from '../../lib/components/Preference';
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';
import { SubViewHeader } from '../../lib/components/subHeader';

/* Result */
import Result from 'iotera-base/result'

/* React Router */
import { withRouter } from 'react-router-dom'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'
import { actions as loadingActions } from '../../redux/ducks/loading'

/* Routes */
import { domainIsTenant as dit, S } from '../../routes/routes'

/* Object Json */
import { isEmpty, isString, isNumber, isNone } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType, parse, stringify, safeDeepDel, deepClone, clean, size } from 'iotera-base/json';
import { hasWhiteSpace } from '../../lib/function';

import { getLayoutsFromDashboard } from '../../lib/position/react-grid-layout';
import IoteraClass from '../../lib/components/react/react-class';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const DialogVarAdd = lazy(() => import('./dialog/var-add/index').then(module => ({ default: module.DialogVarAdd })));
const DialogVarList = lazy(() => import('./dialog/var-list/index').then(module => ({ default: module.DialogVarList })));
const DialogVisualization = lazy(() => import('./dialog/visualization/index').then(module => ({ default: module.DialogVisualization })));
const DashboardMap = lazy(() => import('./map-component/index').then(module => ({ default: module.DashboardMap })));
const DashboardPosition = lazy(() => import('./position/index').then(module => ({ default: module.DashboardPosition })));

const INIT_DASHBOARD = "INIT_DASHBOARD";
const INIT_DASHBOARD_CURR = "INIT_DASHBOARD_CURR";
const INIT_DEVICES = "INIT_DEVICES";
const GET_DEVICES = "GET_DEVICES";
const INIT_SENSORS = "INIT_SENSORS";
const INIT_TAGS = "INIT_TAGS";
const GET_SENSORS = "GET_SENSORS";
const EDIT = "EDIT";
const WKEY = "DASHBOARD_ADD_COMPONENT";
let wSelector = buildWSelector(WKEY)
let wBoundAction = buildWBoundActions(WKEY)

class DashboardAdd extends IoteraClass {
  constructor(props) {
    super(props);
    const dashboardId = safeDeepGet(this, ['props', 'id']);
    this.state = {
      first: true,
      firstInit: true,
      loading: true,
      dashboardId,
      catCard: '',
      typeSingle: TYPE_CUSTOM,
      typeList: '',
      typeChart: '',
      typeControl: '',
      typeControlAuto: true,
      finalCat: '',
      devices: {},
      devices_label: {},
      sensors: {},
      dialogAddVar: false,
      dialogListVar: false,
      dialogVisualization: false,
      positionX: 0,
      positionY: 0,
      cardWidth: '',
      cardHeight: '',
    }
    this.emptyState = this.emptyState.bind(this);
    this.positionNotNull = this.positionNotNull.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.executeChange = this.executeChange.bind(this);
    this.handleChangeSelectNoCat = this.handleChangeSelectNoCat.bind(this);
    this.handleChangeToggle = this.handleChangeToggle.bind(this);
    this.addNewVar = this.addNewVar.bind(this);
    this.openVisualization = this.openVisualization.bind(this);
    this.saveDashboardCompo = this.saveDashboardCompo.bind(this);
    this.executeSave = this.executeSave.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { dashboardId } = _state
    if (isEmpty(dashboardId)) {
      return;
    }
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    // Get dashboard
    _props.wInitRequestCall(
      {
        requests: {
          [INIT_DASHBOARD]: {
            wparam: { ...domainIsTenant, path: '/service/web/application/nav/get/id/' + dashboardId },
            wcallback: {
              started: function (id) {
                _props.showLoading();
              },
              finished: function (id, result) {
                if (result['code'] === 200) {
                } else {
                  _this.setState({ loading: false })
                }
                _props.hideLoading();
              }
            },
            wreducer: {
              rparse: function (id, result, rpayload) {
                let item = {};
                let dashboard = rpayload;
                let parent = safeDeepGetWithType(dashboard, ['parent'], '');
                let path = safeDeepGetWithType(dashboard, ['path'], '');
                let conf_dashboard = safeDeepGetWithType(dashboard, ['conf_dashboard'], {});
                let decimal = safeDeepGetWithType(conf_dashboard, ['view', 'decimal'], 2);
                let refresh = safeDeepGetWithType(conf_dashboard, ['config', 'refresh'], 0);
                refresh = '' + refresh;
                item.label = safeDeepGetWithType(dashboard, ['label'], '');
                let desc = safeDeepGetWithType(dashboard, ['desc'], '');
                if (desc === '') {
                  desc = null
                }
                item.desc = desc;
                item.dashboard = stringify(safeDeepGetWithType(dashboard, ['conf_dashboard'], {}));
                if (parent !== '') {
                  item.parent = parent;
                }
                clean(item)
                _this.setState({ loading: false, decimal, refresh, path })
                return item;
              }
            }
          },
          [INIT_DASHBOARD_CURR]: {
            wparam: { ...domainIsTenant, path: '/service/web/application/nav/list/nin/' + dashboardId },
            wcallback: {
              started: function (id) {
                _props.showLoading();
              },
              finished: function (id, result) {
                if (result['code'] === 200) {
                }
                _props.hideLoading();
              }
            }
          },
          [INIT_DEVICES]: {
            wparam: {
              ...domainIsTenant, path: '/service/web/application/nav/device/devices',
            },
            wcallback: {
              started: function (id) {
                _props.showLoading();
              },
              finished: function (id, result) {
                if (result.code === Result.HTTP.OK) {
                  const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                  if (responseResult === Result.SUCCESS) {
                    _this.setState({
                      devices: safeDeepGetWithType(result, ['body', 'devices'], {}),
                      devices_label: safeDeepGetWithType(result, ['body', 'devices_label'], {})
                    })
                  }
                }
              }
            }
          },
          [INIT_SENSORS]: {
            wparam: {
              ...domainIsTenant, path: '/service/web/application/nav/device/sensors',
            },
            wcallback: {
              started: function (id) {
                _props.showLoading();
              },
              finished: function (id, result) {
                if (result.code === Result.HTTP.OK) {
                  const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                  if (responseResult === Result.SUCCESS) {
                    _this.setState({ sensors: safeDeepGetWithType(result, ['body', 'sensors'], {}) })
                  }
                }
              }
            }
          },
          [INIT_TAGS]: {
            wparam: {
              ...domainIsTenant, path: '/service/web/application/nav/tag/list',
            },
            wcallback: {
              started: function (id) {
                _props.showLoading();
              },
              finished: function (id, result) {
                if (result.code === Result.HTTP.OK) {
                  const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                  if (responseResult === Result.SUCCESS) {
                    _this.setState({ tags: safeDeepGetWithType(result, ['body', 'tags'], []) })
                  }
                }
              }
            }
          }
        }
      })
    _props.wSetConfig({
      single_config: {
        [EDIT]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/nav/edit"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {

                  _this.setState({
                    loading: false
                  })
                  // Magic to refresh routes
                  _props.history.push('..' + S + _this.state.path)
                  _props.showSingleNotification({ message: 'Add Dashboard Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Add Dashboard Gagal', position: 'tr', level: 'error' });
            }
          }
        },
        [GET_DEVICES]: {
          wparam: {
            ...domainIsTenant, path: '/service/web/application/nav/device/devices',
          },
          wenv: { params: GET_DEVICES },
          wcallback: {
            started: function (id) {
              _props.showLoading();
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    devices: safeDeepGetWithType(result, ['body', 'devices'], {}),
                    devices_label: safeDeepGetWithType(result, ['body', 'devices_label'], {})
                  })
                }
              }
            }
          }
        },
        [GET_SENSORS]: {
          wparam: {
            ...domainIsTenant, path: '/service/web/application/nav/device/sensors',
          },
          wenv: { params: GET_SENSORS },
          wcallback: {
            started: function (id) {
              _props.showLoading();
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({ sensors: safeDeepGetWithType(result, ['body', 'sensors'], {}) })
                }
              }
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { dashboardId } = _state;
    if (isEmpty(dashboardId)) {
      return;
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  getNewDeviceSensor(cat) {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    setTimeout(function () {
      if (cat === null || cat === undefined) {
        cat = safeDeepGetWithType(_state, ['finalCat'], '')
      }
      let param = {};
      if (isCommandCard(cat)) {
        param.config = true;
      }
      if (isTagsAvailable(cat)) {
        let tags = safeDeepGetWithType(_state, ['model', 'tags'], []);
        const length = tags.length;
        if (length > 0)
          param.tags = tags;
      }
      _props.wSingleRequestCall({
        id: GET_DEVICES,
        param
      })
      _props.wSingleRequestCall({
        id: GET_SENSORS,
        param
      })
    }, 500);
  }

  addNewVar() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { devices, sensors } = _state
    if (isEmpty(devices) && isEmpty(sensors)) {
      _props.showSingleNotification({ message: 'Tidak ada data berdasarkan penanda!', level: 'error' });
      return;
    }
    _this.setState({ dialogAddVar: true })
  }

  openVisualization() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { devices, sensors, finalCat } = _state
    const emptyDev = isEmpty(devices);
    const emptySen = isEmpty(sensors);
    if (emptyDev && emptySen && finalCat !== TYPE_LIST_TRANSACTION) {
      _props.showSingleNotification({ message: 'Tidak ada data berdasarkan penanda!', level: 'error' });
      return;
    }
    if (isNormalCommand(finalCat) && emptySen) {
      _props.showSingleNotification({ message: 'Tidak ada data berdasarkan penanda!', level: 'error' });
      return;
    }
    _this.setState({ dialogVisualization: true, dialogVisualizationAfterClick: true })
  }

  saveDashboardCompo() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const currDashboard = parse(safeDeepGetWithType(_props, ['item', 'dashboard'], ''));
    let newDash = {}
    let newDashCompo = {}
    let key = safeDeepGetWithType(_state, ['dashKey'], '');
    let cat = safeDeepGetWithType(_state, ['finalCat'], '');
    let x = safeDeepGet(_state, ['positionX']);
    let y = safeDeepGet(_state, ['positionY']);
    let w = safeDeepGet(_state, ['cardWidth']);
    let h = safeDeepGet(_state, ['cardHeight']);
    let _var = safeDeepGetWithType(_state, ['_var'], {});
    let model = safeDeepGetWithType(_state, ['model'], {});
    let view = safeDeepGetWithType(_state, ['view'], {});
    let refreshString = safeDeepGet(_state, ['refresh'])
    if (refreshString === '') {
      _props.showSingleNotification({ message: 'Refresh rate tidak boleh kosong!', level: 'error' });
      return;
    }
    let refresh = parseInt(refreshString);
    if (refresh !== 0 && refresh < 500) {
      _props.showSingleNotification({ message: 'Refresh rate harus lebih besar dari 500 (ms) atau 0 (untuk auto)!', level: 'error' });
      return;
    }
    const decimal = safeDeepGetWithType(_state, ['decimal'], 2);
    let stopSubmit = true;
    if (isString(y)) {
      y = parseInt(y);
    }
    let tempModel = deepClone(model);
    safeDeepDel(tempModel, ['tags'])
    if (!isEmpty(tempModel) || cat === TYPE_DROPDOWN_SELECTOR) {
      stopSubmit = false
    }
    if (key === '') {
      _props.showSingleNotification({ message: 'Component key tidak boleh kosong!', level: 'error' });
      return
    }
    if (stopSubmit) {
      _props.showSingleNotification({ message: 'Masih ada data yang tidak lengkap!', level: 'error' });
      return
    }
    if (cat === TYPE_MAP) {
      let latitude = safeDeepGetWithType(model, ['latitude'], '');
      let longitude = safeDeepGetWithType(model, ['longitude'], '');
      let status = safeDeepGetWithType(model, ['status'], '');
      let tags = safeDeepGetWithType(model, ['tags'], []);
      if (latitude === '') {
        _props.showSingleNotification({ message: 'Latitude tidak boleh kosong', level: 'error' });
        return;
      } else if (longitude === '') {
        _props.showSingleNotification({ message: 'Longitude tidak boleh kosong', level: 'error' });
        return;
      } else {
        model.latitude = '{' + latitude + '}'
        model.longitude = '{' + longitude + '}'
        model.status = '{' + status + '}'
      }
      model.tags = tags;
      safeDeepDel(model, ['tagsAuto'])
      safeDeepDel(model, ['tagsManual'])
    }
    let modelToSave = {}
    if ('output' in model) {
      let output = model.output;
      output = arrToVarArr(output);
      modelToSave.output = output;
    }
    if (!isCommand(cat)) {
      if ('value' in model) {
        let value = model.value;
        value = stringToVar(value);
        modelToSave.value = value;
      }
    }
    view.decimal = decimal;
    let cleanVar = deepClone(_var);
    let cleanView = deepClone(view);
    safeDeepDel(cleanView, ['visTags'])
    for (let varKey in cleanVar) {
      let currVar = cleanVar[varKey];
      safeDeepDel(currVar, ['queryType'])
      safeDeepDel(currVar, ['_varType'])
    }
    let config = refresh === null ? null : { refresh };
    newDashCompo = {
      cat, x, y, w, h, config, var: cleanVar, model, view: cleanView
    }
    clean(newDashCompo)
    newDash = {
      [key]: newDashCompo
    }
    if (key in safeDeepGetWithType(currDashboard, ['dashboard'], {})) {
      ioteraConfirmAlert(
        'Component key sudah terdaftar',
        <span>Apakah anda yakin untuk tetap menyimpan dengan component key saat ini?<br />
        (dashboard dengan component key yang sama akan tergantikan)</span>,
        null,
        () => this.executeSave(newDash, currDashboard),
        null,
        null
      )
    } else {
      this.executeSave(newDash, currDashboard)
    }
  }

  executeSave(_new, curr) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const id = safeDeepGet(_state, ['dashboardId']);
    let currDash = safeDeepGetWithType(curr, ['dashboard'], {})
    let finalDash = { ...currDash, ..._new }
    curr.dashboard = finalDash;
    const layout = getLayoutsFromDashboard(finalDash)
    localStorage.setItem(id, stringify(layout));
    _props.wSingleRequestCall({
      id: EDIT,
      body: {
        id,
        conf_dashboard: curr
      }
    });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  handleChangeToggle = (value) => {
    const _this = this
    const _state = _this.state
    let currFinalType = safeDeepGet(_state, ['finalCat'])
    const changeValue = !value;
    const { finalCat } = _state
    currFinalType = getControlReverse(finalCat, changeValue)
    const _var = safeDeepGetWithType(_state, ['_var'], {})
    if (!isEmpty(_var)) {
      ioteraConfirmAlert(
        'Semua variabel akan di hapus!',
        <span>Apakah anda yakin untuk mengganti categori ini?<br />(semua variabel lokal yang telat terdaftar akan dihapus)</span>,
        null,
        () => this.executeChange('typeControlAuto', value, currFinalType),
        null,
        null
      )
      return;
    }
    _this.setState({ typeControlAuto: changeValue, finalCat: currFinalType, model: {}, view: {} })
    _this.getNewDeviceSensor(currFinalType)
  }

  emptyState() {
    this.setState({
      typeSingle: 'CUSTOM',
      typeList: '',
      typeChart: '',
      typeControl: '',
      typeControlAuto: true,
      // TODO remove initiate
      positionX: 0,
      positionY: 0,
      cardWidth: '',
      cardHeight: '',
      _var: {}
    })
  }

  positionNotNull() {
    const _this = this
    const _state = _this.state
    const { positionX, positionY, cardHeight, cardWidth } = _state
    let final =
      (isNumber(positionX) && !isNone(positionX)) &&
      (isNumber(positionY) && !isNone(positionY)) &&
      (isNumber(cardHeight) && !isNone(cardHeight)) &&
      (isNumber(cardWidth) && !isNone(cardWidth))
    return final
  }

  handleChange(event) {
    const _this = this
    const _state = _this.state
    const name = safeDeepGetWithType(event, ['target', 'name'], '')
    const value = safeDeepGet(event, ['target', 'value'], '')
    if (name === 'tags') {
      let model = safeDeepGetWithType(_state, ['model'], {})
      _this.setState({ model: { ...model, tags: value } })
      return;
    }
    _this.setState({ [name]: value })
  }

  handleChangeSelect(event) {
    const _this = this
    const _state = _this.state
    const name = safeDeepGetWithType(event, ['target', 'name'], '')
    const value = safeDeepGet(event, ['target', 'value'], '')
    if (name === 'catCard' || name === 'typeList' || name === 'typeChart' || name === 'typeControl') {
      const current = safeDeepGetWithType(_state, [name], '');
      if (current !== '' && value !== current) {
        const _var = safeDeepGetWithType(_state, ['_var'], {})
        if (!isEmpty(_var)) {
          ioteraConfirmAlert(
            'Semua variabel akan di hapus!',
            <span>Apakah anda yakin untuk mengganti categori ini?<br />(semua variabel lokal yang telat terdaftar akan dihapus)</span>,
            null,
            () => this.executeChange(name, value),
            null,
            null
          )
          return;
        }
      }
    }
    _this.executeChange(name, value)
  }

  executeChange(name, value, finalCat) {
    const _this = this
    const _state = _this.state
    const { typeControlAuto } = _state
    if (finalCat !== undefined) {
      _this.setState({ [name]: value, finalCat, _var: {} })
      return;
    }
    if (name === 'catCard') {
      _this.emptyState();
      _this.setState({ [name]: value, finalCat: value, model: {}, view: {} })
      _this.getNewDeviceSensor(value)
    }
    if (name === 'typeControl') {
      const currFinalType = getControlReverse(value, typeControlAuto)
      _this.setState({ [name]: value, finalCat: currFinalType, first: true, _var: {}, model: {}, view: {} })
      _this.getNewDeviceSensor(currFinalType)
    } else if (name !== 'typeSingle' && value !== 'LIST' && value !== 'CHART' && value !== 'CONTROL') {
      _this.setState({
        [name]: value, finalCat: value, first: true,
        _var: {}, model: {}, view: {}
      })
      _this.getNewDeviceSensor(value)
    } else if (value === 'LIST' || value === 'CHART' || value === 'CONTROL') {
      _this.setState({
        [name]: value, finalCat: '',
        _var: {}, model: {}, view: {}
      })
    } else {
      _this.setState({ [name]: value })
    }
  }

  handleChangeSelectNoCat(event) {
    const name = safeDeepGetWithType(event, ['target', 'name'], '')
    const value = safeDeepGet(event, ['target', 'value'], '')
    this.setState({ [name]: value })
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let dashKey = safeDeepGetWithType(_state, ['dashKey'], '');
    let refresh = safeDeepGetWithType(_state, ['refresh'], '0')
    let decimal = safeDeepGetWithType(_state, ['decimal'], 2)
    let catCard = safeDeepGetWithType(_state, ['catCard'], '')
    let finalCat = safeDeepGetWithType(_state, ['finalCat'], '')
    let firstInit = safeDeepGet(_state, ['firstInit'], false);
    let typeSingle = safeDeepGetWithType(_state, ['typeSingle'], '');
    let typeList = safeDeepGetWithType(_state, ['typeList'], '');
    let typeChart = safeDeepGetWithType(_state, ['typeChart'], '');
    let typeControl = safeDeepGetWithType(_state, ['typeControl'], '');
    let typeControlAuto = safeDeepGetWithType(_state, ['typeControlAuto'], true);
    let model = safeDeepGetWithType(_state, ['model'], {});
    let showSubmit = false;
    if (!isEmpty(model) || finalCat === TYPE_DROPDOWN_SELECTOR) {
      let modelWithoutTags = deepClone(model);
      safeDeepDel(modelWithoutTags, ['tags'])
      if (!isEmpty(modelWithoutTags) || finalCat === TYPE_DROPDOWN_SELECTOR)
        showSubmit = true
    }
    let dashKeyError = false;
    let helperText = null;
    if (hasWhiteSpace(dashKey)) {
      dashKeyError = true;
      helperText = 'Tidak boleh mengandung spasi'
    }
    let dataToShow = {};
    let item = safeDeepGetWithType(_props, ['item'], {});
    if (!isEmpty(item)) {
      dataToShow = item;
      if (firstInit) {
        let dashConf = parse(safeDeepGetWithType(dataToShow, ['dashboard'], '{}'))
        let varGlobal = safeDeepGetWithType(dashConf, ['var'], {})
        _this.setState({ firstInit: false, varGlobal })
      }
    }
    let _varGlobal = safeDeepGet(_state, ['varGlobal'], {});
    let _var = safeDeepGet(_state, ['_var'], {});
    let varGlobalLength = size(_varGlobal)
    let varLocalLength = size(_var)
    const { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let tags = safeDeepGet(_state, ['tags'], []);
    let currTags = safeDeepGetWithType(model, ['tags'], []);
    let tagsOption = []
    for (let i = 0; i < tags.length; i++) {
      let tag = tags[i];
      tagsOption.push(
        <MenuItem key={tag} value={tag}>
          <Checkbox color='primary' checked={currTags.indexOf(tag) > -1} />
          <ListItemText primary={tag} />
        </MenuItem>
      )
    }
    const refreshInt = parseInt(refresh)
    let errorRefresh = (refreshInt !== 0 && refreshInt < 500) || isNaN(parseInt(refresh))
    let refreshHelper = 'Refresh rate dalam satuan milisecond (ms), akan di-set auto jika refresh rate = 0'
    if (errorRefresh) {
      refreshHelper = 'Refresh rate harus merupakan angka >= 500 atau 0'
    }
    if (!isEmpty(dataToShow)) {
      return (
        <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
          <div className="view">
            <SubViewHeader title='Tambah komponen dashboard' subTitle="Tentukan komponen yang akan ditampilkan" />
            <div className="io-container mt-12">
              <form>
                <FormControl required style={{ minWidth: '100%' }} >
                  <TextField
                    label="Component Key"
                    value={dashKey}
                    autoFocus
                    error={dashKeyError}
                    onChange={_this.handleChange}
                    type="string"
                    margin='dense'
                    inputProps={{ name: "dashKey" }}
                    helperText={helperText}
                  />
                </FormControl>
                <FormControl style={{ minWidth: '45%', marginRight: 10 }} >
                  <TextField
                    error={errorRefresh}
                    label="Refresh Rate"
                    value={refresh}
                    onChange={_this.handleChange}
                    type="number"
                    margin='dense'
                    inputProps={{ name: "refresh", min: "500", step: "1" }}
                    helperText={refreshHelper}
                  />
                </FormControl>
                <FormControl required style={{ minWidth: '45%', marginRight: 10, marginTop: 5 }}>
                  <InputLabel>Desimal yang akan ditampilkan</InputLabel>
                  <Select
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    value={decimal}
                    onChange={_this.handleChange}
                    inputProps={{
                      name: 'decimal'
                    }}
                  >
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>0.1</MenuItem>
                    <MenuItem value={2}>0.01</MenuItem>
                    <MenuItem value={3}>0.001</MenuItem>
                    <MenuItem value={4}>0.0001</MenuItem>
                    <MenuItem value={5}>0.00001</MenuItem>
                  </Select>
                </FormControl>
                <FormControl required style={{ minWidth: '100%' }} >
                  <InputLabel>Kategori</InputLabel>
                  <Select
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    value={catCard}
                    onChange={_this.handleChangeSelect}
                    inputProps={{
                      name: 'catCard'
                    }}
                  >
                    <MenuItem value={CAT_CHART}>Chart</MenuItem>
                    <MenuItem value={CAT_CONTROL}>Control</MenuItem>
                    <MenuItem value={TYPE_DROPDOWN_SELECTOR}>Dropdown Selector</MenuItem>
                    <MenuItem value={CAT_LIST}>List</MenuItem>
                    <MenuItem value={TYPE_MAP}>Map</MenuItem>
                    <MenuItem value={TYPE_CARD_VALUE}>Single Value</MenuItem>
                    <MenuItem value={TYPE_THREE_PHASE}>Three Phase</MenuItem>
                    <MenuItem value={TYPE_TITLE}>Title</MenuItem>
                  </Select>
                </FormControl>
                {
                  catCard === TYPE_CARD_VALUE &&
                  <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
                    <InputLabel>Tipe</InputLabel>
                    <Select
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      value={typeSingle}
                      onChange={this.handleChangeSelect}
                      inputProps={{
                        name: 'typeSingle'
                      }}
                    >
                      <MenuItem disabled value="_!dasdsaSvsaasdas+dasda==">
                        <em>Custom</em>
                      </MenuItem>
                      <MenuItem value={TYPE_CUSTOM}>Custom Unit</MenuItem>
                      <MenuItem disabled value="_!dasdsaSvsaasdas+dasda==">
                        <em>Common Use</em>
                      </MenuItem>
                      <MenuItem value={TYPE_AMPERE}>Ampere</MenuItem>
                      <MenuItem value={TYPE_HUMIDITY}>Humidity</MenuItem>
                      <MenuItem value={TYPE_KW}>KW</MenuItem>
                      <MenuItem value={TYPE_KWH}>KWH</MenuItem>
                      <MenuItem value={TYPE_OHM}>Ohm</MenuItem>
                      <MenuItem value={TYPE_PERCENT}>Percentage</MenuItem>
                      <MenuItem value={TYPE_PRESSURE_AIR}>Pressure air</MenuItem>
                      <MenuItem value={TYPE_PRESSURE_WATER}>Pressure water</MenuItem>
                      <MenuItem value={TYPE_RUPIAH}>Sales</MenuItem>
                      <MenuItem value={TYPE_TEMPERATURE_CELCIUS}>Temperature (°C)</MenuItem>
                      <MenuItem value={TYPE_TEMPERATURE_FAHRENHEIT}>Temperature (°F)</MenuItem>
                      <MenuItem value={TYPE_TEMPERATURE_KELVIN}>Temperature (K)</MenuItem>
                      <MenuItem value={TYPE_VERSION}>Version</MenuItem>
                      <MenuItem value={TYPE_VOLT}>Volt</MenuItem>
                      <MenuItem value={TYPE_WATT}>Watt</MenuItem>
                    </Select>
                  </FormControl>
                }
                {
                  catCard === CAT_LIST &&
                  <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
                    <InputLabel>Tipe List</InputLabel>
                    <Select
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      value={typeList}
                      onChange={_this.handleChangeSelect}
                      inputProps={{
                        name: 'typeList'
                      }}
                    >
                      <MenuItem value={TYPE_LIST}>Auto (by all/tags)</MenuItem>
                      <MenuItem value={TYPE_LIST_CUSTOM}>Manual</MenuItem>
                      <MenuItem value={TYPE_LIST_TRANSACTION}>Transaction</MenuItem>
                    </Select>
                  </FormControl>
                }
                {
                  catCard === CAT_CHART &&
                  <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
                    <InputLabel>Tipe Chart</InputLabel>
                    <Select
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      value={typeChart}
                      onChange={_this.handleChangeSelect}
                      inputProps={{
                        name: 'typeChart'
                      }}
                    >
                      <MenuItem value={TYPE_GRAPH_AREA_MONITORING}>Area</MenuItem>
                      <MenuItem value={TYPE_GRAPH_BAR_MONITORING}>Bar</MenuItem>
                      <MenuItem value={TYPE_GRAPH_LINE_MONITORING}>Line</MenuItem>
                      <MenuItem value={TYPE_GRAPH_PIE}>Pie</MenuItem>
                    </Select>
                  </FormControl>
                }
                {
                  catCard === CAT_CONTROL &&
                  <React.Fragment>
                    <FormControl required style={{ minWidth: '100%', marginTop: 10 }} >
                      <InputLabel>Tipe Perintah</InputLabel>
                      <Select
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        value={typeControl}
                        onChange={_this.handleChangeSelect}
                        inputProps={{
                          name: 'typeControl'
                        }}
                      >
                        <MenuItem value={INPUT_TOGGLE_TAGS_CARD}>Boolean Input</MenuItem>
                        <MenuItem value={INPUT_NUMBER_TAGS_CARD}>Integer Input</MenuItem>
                        <MenuItem value={INPUT_TEXT_TAGS_CARD}>String Input</MenuItem>
                        <MenuItem value={BUTTON_TAGS_CARD}>Without Input</MenuItem>
                      </Select>
                    </FormControl>
                    {typeControl !== '' &&
                      <FormControl required >
                        <span>
                          <i>Manual</i>
                          <Switch checked={typeControlAuto} color="primary" onChange={() => _this.handleChangeToggle(typeControlAuto)} />
                          <i>By All/Tags</i>
                        </span>
                      </FormControl>
                    }
                  </React.Fragment>
                }
                {
                  finalCat !== '' &&
                  <Suspense fallback={<div />}>
                    <DashboardPosition _parent={this} />
                  </Suspense >
                }
                {isTagsAvailable(finalCat) &&
                  <div>
                    <FormControl style={{ minWidth: '100%', marginTop: 10 }}  >
                      <InputLabel>Penanda</InputLabel>
                      <Select
                        multiple
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        value={currTags}
                        onChange={_this.handleChange}
                        onClose={() => _this.getNewDeviceSensor()}
                        inputProps={{
                          name: 'tags'
                        }}
                        renderValue={selected => (
                          <div >
                            {selected.map(value => (
                              <Chip key={value} label={value} style={{ marginLeft: 5 }} />
                            ))}
                          </div>
                        )}
                      >
                        {tagsOption}
                      </Select>
                      <FormHelperText>Kosongkan penanda bila ingin menampilkan seluruh data</FormHelperText>
                    </FormControl>
                  </div>
                }
                {
                  finalCat === TYPE_MAP && varLocalLength > 0 &&
                  <Suspense fallback={<div />}>
                    <DashboardMap _parent={_this} />
                  </Suspense >
                }
                <div className='row' style={{ minWidth: '100%' }} >
                  <div className='col-md-6' style={{ marginTop: 10 }}>
                    {
                      (finalCat !== '' && _this.positionNotNull() && finalCat !== TYPE_DROPDOWN_SELECTOR) &&
                      <span>
                        {(varGlobalLength > 0 || varLocalLength > 0) &&
                          <Button variant="outlined" type="button"
                            onClick={(e) => _this.setState({ dialogListVar: true, hasAction: true })}
                            style={{ marginRight: 10 }} >List Variabel</Button>
                        }
                        {
                          varLocalLength > 0 &&
                          <Button variant='outlined' color='primary'
                            onClick={(e) => _this.setState({ dialogAddVar: true })} >Tambah Variabel</Button>
                        }
                      </span>
                    }
                  </div>
                  <div className='col-md-6 button-right' style={{ marginTop: 10 }}>
                    <Button variant="outlined" type="button" onClick={(e) => _props.history.goBack()} >Batal</Button>
                    {varLocalLength === 0 ?
                      <span>
                        {(finalCat !== '' && _this.positionNotNull() && !isNormalCommand(finalCat) &&
                          finalCat !== TYPE_LIST_TRANSACTION && finalCat !== TYPE_DROPDOWN_SELECTOR) &&
                          <Button variant='outlined' color='primary' onClick={_this.addNewVar}
                            style={{ marginLeft: 10 }} >Tambah Variabel</Button>
                        }
                        {(finalCat !== '' && this.positionNotNull() &&
                          (isNormalCommand(finalCat) || finalCat === TYPE_LIST_TRANSACTION)) &&
                          <Button variant='outlined' color='primary' onClick={_this.openVisualization}
                            style={{ marginLeft: 10 }} >Visualisasi</Button>
                        }
                      </span>
                      :
                      <span>
                        {((finalCat !== '' && _this.positionNotNull()) && finalCat !== TYPE_MAP) &&
                          <Button variant='outlined' color='primary' onClick={_this.openVisualization}
                            style={{ marginLeft: 10 }} >Visualisasi</Button>
                        }
                      </span>
                    }
                    {showSubmit && (finalCat !== '') && _this.positionNotNull() &&
                      <Button variant='contained' color='primary' onClick={_this.saveDashboardCompo}
                        style={{ marginLeft: 10 }}>Simpan</Button>
                    }
                  </div>
                </div>
              </form>
              <Suspense fallback={<div />}>
                <DialogVarList _parent={_this} />
              </Suspense >
              <Suspense fallback={<div />}>
                <DialogVarAdd _parent={_this} />
              </Suspense>
              {((finalCat !== '' && _this.positionNotNull()) && finalCat !== TYPE_MAP) &&
                <Suspense fallback={<div />}>
                  <DialogVisualization _parent={_this} />
                </Suspense>
              }
            </div>
          </div>
        </Loader>
      );
    } else {
      return (
        <div className="view">
          <SubViewHeader title='Tambah Komponen' subTitle='Formulir komponen dashboard' />
          <div className="view-content-dashboard" />
        </div>
      );
    }
  }
}

const mapStateToProps = function (state, ownProps) {
  let data = wSelector.getMappedState(state)
  return {
    item: wSelector.getRPayloadFromMappedState(data, INIT_DASHBOARD),
    items: wSelector.getMappedRPayload(state, INIT_DASHBOARD_CURR, 'navs'),
    init_devices: wSelector.getRPayloadFromMappedState(data, INIT_DEVICES),
    updated_devices: wSelector.getMappedRPayload(state, GET_DEVICES),
    init_sensors: wSelector.getMappedRPayload(state, INIT_SENSORS, 'sensors'),
    updated_sensors: wSelector.getMappedRPayload(state, GET_SENSORS, 'sensors'),
    data
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundAction(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(loadingActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardAdd));